<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode }">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapGetters(["isDarkMode"]),
  },
  methods: {
    ...mapActions(["toggleDarkMode"]),
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: "Montserrat", sans-serif;
  background-color: white;
  color: black;
  line-height: 1.6;
}

h1 {
  font-family: "Onest", sans-serif;
  font-variation-settings: "wght" 900;
  font-size: 2.25rem;
}

h2 {
  text-align: center;
  margin-bottom: 10px;
  font-family: "Onest", sans-serif;
  font-weight: bold;
  font-size: 2.25rem;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.highlight {
  color: #42b983; /* naranja bonito, puedes adaptarlo a tu branding */
  font-weight: 600;
}

.dark-mode {
  background-color: #050d1a;
  color: #f0f0f0;
}
</style>
